<pl-audio *ngIf="block" [link]="block.data.link" [title]="block.data.title" />
